module.exports = __webpack_public_path__ + "static/img/a027.6e630df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a027.jpg
// module id = 2rOE
// module chunks = 0